window.addEventListener('pageshow', ({ persisted }) => {
    if (persisted) {
        window.location.reload();
    }
});
